<template>
  <div id="container" class="store_st_list">
    <!-- Location START -->
    <!-- TODO: Should be a component -->

    <div class="location_wrap">
      <div class="location">
        <span>{{ $t('views.store.categorybooks.6976') }}</span>
        <span class="svg_next">></span>
        <div v-on-clickaway="closeListMenu" class="current">
          <div class="select_area" @click.prevent.stop="toggleListMenu">
            <div :class="{ active: isListMenuOpen }" class="select_item">
              <button type="button" class="select_option">
                <span class="txt">{{ pageTitle }}</span>
                <span class="arrow blind">열기</span>
              </button>
              <ul
                v-if="!isMainCategoriesLoading && getMainCategories"
                class="select_list"
              >
                <li
                  v-for="(category, idx) in getMainCategories.filter(
                    (c) => c.id !== currentCategory
                  )"
                  :key="idx"
                >
                  <a href="#" @click="changeCategory(category)">
                    {{ category.title }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <template
          v-if="
            currentCategory !== 'A' &&
            getMainSubcategories &&
            getMainSubcategories.length
          "
        >
          <span class="svg_next">></span>

          <div v-on-clickaway="closeSubListMenu" class="current">
            <div class="select_area" @click.prevent.stop="toggleSubListMenu">
              <div :class="{ active: isSubListMenuOpen }" class="select_item">
                <button type="button" class="select_option">
                  <span class="txt">
                    {{
                      currentSubCategory
                        ? currentSubCategory.title
                        : $t('views.categorybooks.department')
                    }}
                  </span>
                  <span class="arrow blind">열기</span>
                </button>
                <ul
                  v-if="!isMainCategoriesLoading && getMainSubcategories"
                  class="select_list"
                >
                  <li v-for="(sub, idx) in getMainSubcategories" :key="idx">
                    <a href="#" @click="changeSubCategory(sub)">
                      {{ sub.title }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- Location END -->

    <div class="section pb">
      <div class="inner">
        <BaseSortBar
          :current-page-title="sortTitle"
          :current-book-count="getStoreBooksTotalCount"
          :current-sort-value="currentSortValue"
          :landscape="landscapeMode"
          :current-subcategorynm="getCurrentSubCategoryNm"
          @changeMode="viewModeChange"
          @sorting="changeSortOrder"
        />
        <div
          class="eplist item_columns_grid"
          :class="[landscapeMode ? 'item_landscape' : 'item_image']"
        >
          <ul
            v-if="isStoreBooksLoading || getStoreBooksTotalCount > 0"
            class="item_list"
          >
            <BaseBook
              v-for="(book, idx) in getStoreBooks"
              :key="idx"
              :book="book"
              :landscape="landscapeMode"
              :display-price="true"
              :current-category="currentCategory"
              :current-sub-category="getCurrentSubCategory"
              :current-sub-category-name="getCurrentSubCategoryNm || '학부'"
              :current-page="currentPage"
              :current-sort="currentSortValue"
            />
            <Spinner
              :active="isStoreBooksLoading"
              loader="bars"
              color="#007FA2"
              background-color="#ffffff"
              :opacity="0.7"
              :is-full-page="false"
              :width="128"
              :height="128"
            />
          </ul>
          <EmptyData v-else data-tp="책" />
          <Pagination
            v-if="getStoreBooksTotalCount"
            :current-page="currentPage"
            :total-count="getStoreBooksTotalCount"
            :item-per-page="booksPerPage"
            @paginate="paginate"
          />
        </div>
      </div>
    </div>

    <HelpDesk />
  </div>
</template>

<script>
import HelpDesk from '@/components/common/HelpDesk.vue'
import { mapGetters } from 'vuex'

import {
  // STORE_CATEGORIES_GET_LIST,
  STORE_CATEGORIES_GET,
  STORE_CATEGORY_BOOKS_GET_LIST
} from '@/store/types'
import EmptyData from '../../components/common/EmptyData.vue'
import BaseSortBar from '../../components/base/BaseSortBar.vue'
import BaseBook from '@/components/base/BaseBook.vue'

export default {
  name: 'CategoryBooks',
  components: { HelpDesk, EmptyData, BaseSortBar, BaseBook },
  // components: { HelpDesk, EmptyData },
  data() {
    return {
      landscapeMode: false,
      isListMenuOpen: false,
      isSubListMenuOpen: false,
      currentPage: parseInt(this.$route.query.page) || 1,
      booksPerPage: 15,
      currentSortValue: this.$route.query.sort || 'SA',
      currentSubCategory: null
    }
  },
  computed: {
    ...mapGetters([
      'getStoreBooks',
      'isStoreBooksLoading',
      'getStoreBooksTotalCount',
      'isMainCategoriesLoading',
      'getMainCategories',
      'getMainSubcategories'
    ]),
    currentCategory() {
      return this.$route.params.category
    },
    getCurrentSubCategory() {
      return this.$route.params.subCategory
    },
    getCurrentSubCategoryNm() {
      return this.$route.params.subCategoryNm
    },
    setCurrentSubCategory() {
      const currentSubCategory = this.$route.params.subCategory
      const subCategory = this.getMainSubcategories?.find(
        (subCategory) => subCategory.id === currentSubCategory
      )
      return subCategory
    },
    pageTitle() {
      if (!this.getMainCategories) return ''
      const category = this.getMainCategories.find(
        (category) => category.id === this.currentCategory
      )
      if (category) {
        return category.title
      } else {
        return ''
      }
    },
    sortTitle() {
      if (!this.getMainCategories) return ''

      const category = this.getMainCategories.find(
        (category) => category.id === this.currentCategory
      )
      if (
        this.currentSubCategory?.title &&
        this.currentSubCategory.title !== '학부'
      ) {
        return this.currentSubCategory.title
      }
      if (
        this.getCurrentSubCategoryNm &&
        this.getCurrentSubCategoryNm !== '학부'
      ) {
        return this.getCurrentSubCategoryNm
      }
      if (this.getCurrentSubCategory && this.getMainSubcategories) {
        const foundSubCategory = this.getMainSubcategories.find(
          (sub) => sub.id === this.getCurrentSubCategory
        )
        if (foundSubCategory && foundSubCategory.title !== '학부') {
          return foundSubCategory.title
        }
      }
      return category?.title || ''
    }
  },
  watch: {
    currentCategory() {
      this.changeCategory({ id: this.currentCategory })
    },
    getCurrentSubCategory() {
      this.changeSubCategory({
        id: this.getCurrentSubCategory,
        title: this.getCurrentSubCategoryNm || '학부'
      })
    }
  },
  async mounted() {
    if (!this.getMainCategories) {
      // await this.$store.dispatch(STORE_CATEGORIES_GET_LIST)
    }

    if (this.currentCategory !== 'A') {
      await this.$store.dispatch(STORE_CATEGORIES_GET, this.currentCategory)
    }

    await this.$store.dispatch(STORE_CATEGORY_BOOKS_GET_LIST, {
      category: this.currentCategory,
      subcategory: this.getCurrentSubCategory,
      sort: this.currentSortValue,
      page: this.currentPage
    })
    if (this.getCurrentSubCategory) {
      this.currentSubCategory = this.setCurrentSubCategory
    }
  },
  methods: {
    closeSubListMenu() {
      this.isSubListMenuOpen = false
    },
    toggleSubListMenu() {
      this.isListMenuOpen = false
      this.isSubListMenuOpen = !this.isSubListMenuOpen
    },
    changeSubCategory(sub) {
      this.currentSubCategory = sub
      this.currentPage = 1
      this.$store.dispatch(STORE_CATEGORY_BOOKS_GET_LIST, {
        page: this.currentPage,
        category: this.currentCategory,
        subcategory: sub.id
      })
      this.$router
        .push({
          name: 'category_books',
          params: {
            category: this.currentCategory,
            subCategory: sub.id,
            subCategoryNm: sub.title
          }
        })
        .catch(() => {})
    },
    toggleListMenu() {
      this.isSubListMenuOpen = false
      this.isListMenuOpen = !this.isListMenuOpen
    },
    closeListMenu() {
      this.isListMenuOpen = false
    },
    normalMode() {
      this.landscape = false
    },
    viewModeChange(value) {
      this.landscapeMode = value
    },
    async changeCategory(category) {
      this.currentPage = 1
      this.currentSubCategory = null
      this.currentSortValue = 'SA'
      await this.$store.dispatch(STORE_CATEGORY_BOOKS_GET_LIST, {
        category: category.id,
        subcategory: this.getCurrentSubCategory
      })
      await this.$store.dispatch(STORE_CATEGORIES_GET, category.id)
      this.$router
        .push({
          name: 'category_books',
          params: {
            category: category.id,
            subCategory: this.currentSubCategory?.id || category.id
          }
        })
        .catch(() => {})
    },
    changeSortOrder(sort) {
      this.currentSortValue = sort.value
      this.currentPage = 1

      const currentSubCategoryId =
        this.currentSubCategory?.id || this.getCurrentSubCategory || ''
      const currentSubCategoryName =
        this.currentSubCategory?.title || this.getCurrentSubCategoryNm || '학부'

      this.$store.dispatch(STORE_CATEGORY_BOOKS_GET_LIST, {
        category: this.currentCategory,
        subcategory: currentSubCategoryId,
        sort: sort.value,
        page: this.currentPage
      })

      this.$router.push({
        name: 'category_books',
        params: {
          category: this.currentCategory,
          subCategory: currentSubCategoryId,
          subCategoryNm: currentSubCategoryName // 이 부분도 추가!
        },
        query: {
          page: this.currentPage,
          sort: this.currentSortValue
        }
      })
    },
    paginate(page) {
      this.currentPage = page

      const currentSubCategoryId =
        this.currentSubCategory?.id || this.getCurrentSubCategory || ''
      const currentSubCategoryName =
        this.currentSubCategory?.title || this.getCurrentSubCategoryNm || '학부'

      this.$store.dispatch(STORE_CATEGORY_BOOKS_GET_LIST, {
        category: this.currentCategory,
        sort: this.currentSortValue,
        page: this.currentPage,
        subcategory: currentSubCategoryId
      })

      this.$router.push({
        name: 'category_books',
        params: {
          category: this.currentCategory,
          subCategory: currentSubCategoryId,
          subCategoryNm: currentSubCategoryName // 이 부분이 누락되었음!
        },
        query: {
          page: this.currentPage,
          sort: this.currentSortValue
        }
      })
    }
  }
}
</script>
<style src="@/assets/css/page_catagory.css" scoped></style>
<style lang="scss" scoped>
#container {
  padding-top: 48px;
  .location_wrap {
    margin: 0 auto;
    max-width: 980px;
  }
}
.eplist {
  min-height: 300px;
}
.vld-overlay.is-active {
  align-items: flex-start;
}
@media (max-width: 1024px) {
  #container {
    padding-top: 0;
  }
  .eplist {
    margin-top: 20px;
  }
}
</style>
